export default __webpack_public_path__ + "static/media/01.c48f6bf7.jpg";